export default __webpack_public_path__ + "static/media/02.0a64c9c4.png";